<template>
	<div class="flex-fill w-100 card" v-if="locations.length > 0">
  	  <div class="card-header">
  	    <h5 class="mb-0 card-title">Annotations liées à des lieux</h5>
      </div>
  	  <div class="p-2 card-body">
  	  	<div style="height: 312px;">
			<div class="map-wrapper h-100">
				<div id="world-map-markers" class="h-100"></div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
export default {
	name: 'WikidataLocations',
	data() {
		return {
			locations: [],
		}
	},
	created() {
   		axios.get('/wikidataLocations').then(response => {
        	this.locations = response.data;
        }).catch(err => {
            console.log(err)
        }).finally(() => this.drawMap());
	},
	methods: {
		drawMap() {
			$('#world-map-markers').vectorMap({
			    map: 'world_mill',
			    regionStyle: {
					initial: {
						fill: '#e3eaef'
					},
		    	},
			    normalizeFunction: 'polynomial',
			    hoverOpacity: 0.7,
			    hoverColor: false,
			    markerStyle: {
			      	initial: {
				        fill: 'rgb(59, 130, 236)',
				        stroke: 'rgb(255, 255, 255)',
				        strokeWidth: 3,
				        strokeOpacity: 0.4,
				        r: 7,
			      	},
			      	hover: {
			    	    strokeWidth: 0,
			    	    cursor: 'pointer'
					},
			    },
			    backgroundColor: 'transparent',
			    markers: this.locations,
			    zoomMax: 12
			});
		}
	},
}
</script>